<div>
    <div class="ib-digital-menu-mmb__meal--menu-wines ib-digital-menu-mmb__meal--item-menu-container">
        <div *ngFor="let wineMenu of menu; let menuIndex = index">
            <div class="ib-digital-menu-mmb__meal--menu-wines-meal-name ib-heading ib-heading--type-1 ib-text--color-important
                    ib-special-separator ib-special-separator--full ib-special-separator--bottom">
                <div class="ib-digital-menu-mmb__meal--menu-wines-meal-name-title">{{wineMenu.name}}</div>
            </div>
            <!-- Desktop View -->
            <div *ngIf="!isMobile" class="ib-digital-menu-mmb__meal--menu-wines-container
                service ib-heading ib-heading--type-1 ib-text--color-important">
                <div *ngFor="let item of wineMenu.items" class="ib-digital-menu-mmb__meal--menu-wines-item row">
                    <div class="col-2 ib-digital-menu-mmb__meal--menu-wines-item__mmb">
                        <img alt="wine image" class=" ib-digital-menu-mmb__meal--menu-wines-item__mmb-images"
                            [src]="originPath + item.images[0].imagePath" (error)="onImgError($event)" />
                    </div>
                    <div class="col-10 ib-digital-menu-mmb__meal--menu-wines-description">
                        <div class="ib-digital-menu-mmb__meal--menu-wines-name service__subtitle ib-text--big">
                            {{item.name}}
                        </div>
                        <p *ngFor="let description of item.description">
                            {{description}}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Mobile View -->
            <div *ngIf="isMobile">
                <div *ngFor="let item of wineMenu.items; let itemIndex = index"
                    class="ib-digital-menu--wine-container-mobile">
                    <div class="ib-digital-menu--wine-container-mobile__img">
                        <img alt="wine image" class="ib-digital-menu-mmb__meal--menu-wines-item__mmb-images"
                            [src]="originPath + item.images[0].imagePath" (error)="onImgError($event)" />
                    </div>
                    <div ngbAccordion #accordion="ngbAccordion" class="ib-digital-menu--wine-container-mobile__content">
                        <div ngbAccordionItem #accordionItem="ngbAccordionItem" [collapsed]="menuIndex !== 0">
                            <div ngbAccordionHeader class="ib-digital-menu--wine-container-mobile__header ib-text--big">
                                <div class="ib-digital-menu-mmb__meal--menu-wines-name">
                                    {{item.name}}
                                </div>
                                <span ngbAccordionToggle
                                    [ngClass]="{'icon-flecha_1_arriba': !accordionItem.collapsed, 'icon-flecha_1_abajo': accordionItem.collapsed}"></span>
                            </div>
                            <div ngbAccordionCollapse>
                                <div ngbAccordionBody>
                                    <ng-template>
                                        <p class="ib-digital-menu--wine-container-mobile__description ib-text ib-text--block ib-text--color-unfocused"
                                            *ngFor="let description of item.description">
                                            {{description}}
                                        </p>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    </div>
</div>
